import { api } from 'services/api';

export class TcomService {
  async getLaudoTcom(data) {
    return api.post('/xpcell-ingenico-tcom/laudo', data);
  }

  async approveLaudoTcom(data) {
    return api.post('/xpcell-ingenico-tcom/laudo/approve', data);
  }
}

export const tcomService = new TcomService();
